import { Navigate, useParams } from 'react-router';

import { PUBLIC_PATH } from 'src/routes/paths';

import { isShareVerified } from '../utils/session-storage';

export interface ShareGuardProps {
  children: React.ReactNode;
}

export function ShareGuard({ children }: ShareGuardProps) {
  const { hisUrl } = useParams<{ hisUrl: string }>();

  if (!hisUrl) {
    return <Navigate to="/" replace />;
  }

  if (!isShareVerified(hisUrl)) {
    return <Navigate to={PUBLIC_PATH.share.verify(hisUrl)} replace />;
  }

  return <>{children}</>;
}
